<template>
  <div>
    <div><el-button type="success" @click="edit">新增课程</el-button></div>
    <div class="ls_flex">
      <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-input v-model="query.title" placeholder="课程名字搜索"></el-input>
      <el-select v-model="query.publishStatus" placeholder="请选择">
        <el-option label="全部状态" :value="null"> </el-option>
        <el-option label="未发布" :value="0"> </el-option>
        <el-option label="已发布" :value="1"> </el-option>
      </el-select>
      <el-button
        type="primary"
        @click="
          query.pageIndex = 1;
          getList();
        "
        >查询</el-button
      >
    </div>
    <el-table style="width: 100%" :data="list">
      <el-table-column prop="title" label="课件名称"> </el-table-column>
      <el-table-column prop="name" label="发布范围">
        <template slot-scope="scope">
          <div style="color: #999; margin-bottom: 15px">
            {{ scope.row.range }}
          </div>
          <div
            style="
              color: rgb(243, 57, 57);
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            :title="scope.row.organization"
          >
            {{ scope.row.organization }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="publishTime" label="发布时间"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          {{ scope.row.publishStatus === 1 ? "已发布" : "未发布" }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <div class="operation-buttons">
            <el-button
              v-if="scope.row.publishStatus === 1"
              type="text"
              @click="publish(scope.row)"
            >
              撤回
            </el-button>
            <template v-else>
              <el-button type="text" @click="publish(scope.row)">发布</el-button>
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            </template>
            <el-button class="delete-button" type="text" @click="del(scope.row.id)">
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="query.pageIndex"
      @current-change="getList"
      :page-size="query.pageSize"
      style="text-align: center; margin-top: 15px"
    >
    </el-pagination>
    <el-dialog
      :title="form.id ? '修改课件' : '新增课程'"
      :visible.sync="show"
      width="760px"
      top="5vh"
      custom-class="course-dialog"
    >
      <el-form class="course-form" label-width="116px">
        <el-form-item label="课件标题">
          <el-input
            v-model="form.title"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="课件地址">
          <el-input v-model="form.url"></el-input>
        </el-form-item>
        <el-form-item label="课件描述">
          <el-input
            v-model="form.coursewareDesc"
            maxlength="200"
            :rows="5"
            type="textarea"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="可用版本">
          <div style="padding-top: 10px">
            <el-checkbox-group v-model="range">
              <el-checkbox
                :label="item.id"
                v-for="item in versionList"
                :key="item.id"
              >
                {{ item.version }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-form-item>
        <el-form-item label="可用学校">
          <el-button
            class="school-toggle"
            type="text"
            @click="schoolExpanded = !schoolExpanded"
          >
            {{ schoolExpanded ? "收起学校列表" : "展开学校列表" }}
            <span v-if="!schoolExpanded && organizationId.length">
              （已选择 {{ organizationId.length }} 所）
            </span>
            <i
              :class="schoolExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            ></i>
          </el-button>
          <el-collapse-transition>
            <div v-show="schoolExpanded" class="school-checkboxes">
              <el-checkbox-group v-model="organizationId">
                <el-checkbox
                  :label="item.id"
                  v-for="item in organizationList"
                  :key="item.id"
                >
                  {{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-collapse-transition>
        </el-form-item>

        <el-divider content-position="left">课程教学内容</el-divider>
        <el-form-item label="章节管理">
          <el-input
            v-model="courseDraft.chapterManagement"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入课程章节安排"
          ></el-input>
        </el-form-item>
        <el-form-item label="课前预习">
          <el-input
            v-model="courseDraft.beforeClass"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入课前预习内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="课中教学">
          <el-input
            v-model="courseDraft.duringClass"
            type="textarea"
            :rows="3"
            maxlength="1000"
            show-word-limit
            placeholder="请输入课中教学内容"
          ></el-input>
        </el-form-item>
        <el-form-item label="课后作业任务">
          <el-input
            v-model="courseDraft.afterClass"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
            placeholder="请输入课后作业任务"
          ></el-input>
        </el-form-item>

        <el-divider content-position="left">附件上传</el-divider>
        <div class="attachment-grid">
          <div class="attachment-card">
            <div class="attachment-title">课件</div>
            <el-upload
              action=""
              multiple
              :auto-upload="false"
              :limit="10"
              :file-list="attachmentFiles.courseware"
              :on-change="handleCoursewareChange"
              :on-remove="handleCoursewareRemove"
              :on-exceed="handleAttachmentExceed"
              accept=".ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar"
            >
              <el-button size="small" type="primary" plain icon="el-icon-upload2">
                选择课件
              </el-button>
            </el-upload>
          </div>
          <div class="attachment-card">
            <div class="attachment-title">教案</div>
            <el-upload
              action=""
              multiple
              :auto-upload="false"
              :limit="10"
              :file-list="attachmentFiles.teachingPlan"
              :on-change="handleTeachingPlanChange"
              :on-remove="handleTeachingPlanRemove"
              :on-exceed="handleAttachmentExceed"
              accept=".doc,.docx,.pdf,.ppt,.pptx,.xls,.xlsx,.zip,.rar"
            >
              <el-button size="small" type="primary" plain icon="el-icon-upload2">
                选择教案
              </el-button>
            </el-upload>
          </div>
          <div class="attachment-card">
            <div class="attachment-title">视频</div>
            <el-upload
              action=""
              multiple
              :auto-upload="false"
              :limit="10"
              :file-list="attachmentFiles.video"
              :on-change="handleVideoChange"
              :on-remove="handleVideoRemove"
              :on-exceed="handleAttachmentExceed"
              accept="video/*"
            >
              <el-button size="small" type="primary" plain icon="el-icon-upload2">
                选择视频
              </el-button>
            </el-upload>
          </div>
          <div class="attachment-card">
            <div class="attachment-title">图片</div>
            <el-upload
              action=""
              multiple
              :auto-upload="false"
              :limit="10"
              :file-list="attachmentFiles.image"
              :on-change="handleImageChange"
              :on-remove="handleImageRemove"
              :on-exceed="handleAttachmentExceed"
              accept="image/*"
            >
              <el-button size="small" type="primary" plain icon="el-icon-upload2">
                选择图片
              </el-button>
            </el-upload>
          </div>
        </div>
        <el-form-item label="">
          <el-button @click="show = false">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      query: {
        pageIndex: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        publishStatus: null,
        title: "",
      },
      show: false,
      form: {
        id: null,
        title: "",
        url: "",
        coursewareDesc: "",
        ranges: "",
        organizationIds: "",
      },
      range: [],
      organizationId: [],
      schoolExpanded: false,
      versionList: [],
      organizationList: [],
      time: [],
      courseDraft: {
        chapterManagement: "",
        beforeClass: "",
        duringClass: "",
        afterClass: "",
      },
      attachmentFiles: {
        courseware: [],
        teachingPlan: [],
        video: [],
        image: [],
      },
    };
  },
  created() {
    this.$ajax
      .post("basic/version/getPage", { pageNum: 1, pageSize: 100 })
      .then((res) => {
        this.versionList = res.list;
      });
    Promise.all([
      this.$ajax.post("institution/play/getList", {
        pageNum: 1,
        pageSize: 100,
      }),
      this.$ajax.post("institution/getList", { pageNum: 1, pageSize: 100 }),
    ]).then((res) => {
      this.organizationList = [...res[0].list, ...res[1].list];
    });
    this.getList();
  },
  methods: {
    del(id) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax
            .get("/admin/courseware/delete", {
              params: { id },
            })
            .then((res) => {
              this.$message.success("删除成功");
              this.getList();
            });
        })
        .catch(() => {});
    },
    edit(item) {
      this.range = [];
      this.organizationId = [];
      this.schoolExpanded = false;
      this.resetCourseDraft();
      if (item) {
        this.form.id = item.id;
        this.form.title = item.title;
        this.form.url = item.url;
        this.form.coursewareDesc = item.coursewareDesc;
        if (item.range) {
          let range = item.range.split(",");
          for (let item of range) {
            let mate = this.versionList.find((oItem) => {
              return oItem.version === item;
            });
            if (mate) {
              this.range.push(mate.id);
            }
          }
        }
        if (item.organization) {
          let organization = item.organization.split(",");
          for (let item of organization) {
            let mate = this.organizationList.find((oItem) => {
              return oItem.name === item;
            });
            if (mate) {
              this.organizationId.push(mate.id);
            }
          }
        }
      } else {
        this.form.id = "";
        this.form.title = "";
        this.form.url = "";
        this.form.coursewareDesc = "";
      }
      this.show = true;
    },
    resetCourseDraft() {
      this.courseDraft = {
        chapterManagement: "",
        beforeClass: "",
        duringClass: "",
        afterClass: "",
      };
      this.attachmentFiles = {
        courseware: [],
        teachingPlan: [],
        video: [],
        image: [],
      };
    },
    updateAttachmentFiles(type, fileList) {
      this.attachmentFiles[type] = fileList.slice();
    },
    handleCoursewareChange(file, fileList) {
      this.updateAttachmentFiles("courseware", fileList);
    },
    handleCoursewareRemove(file, fileList) {
      this.updateAttachmentFiles("courseware", fileList);
    },
    handleTeachingPlanChange(file, fileList) {
      this.updateAttachmentFiles("teachingPlan", fileList);
    },
    handleTeachingPlanRemove(file, fileList) {
      this.updateAttachmentFiles("teachingPlan", fileList);
    },
    handleVideoChange(file, fileList) {
      this.updateAttachmentFiles("video", fileList);
    },
    handleVideoRemove(file, fileList) {
      this.updateAttachmentFiles("video", fileList);
    },
    handleImageChange(file, fileList) {
      this.updateAttachmentFiles("image", fileList);
    },
    handleImageRemove(file, fileList) {
      this.updateAttachmentFiles("image", fileList);
    },
    handleAttachmentExceed() {
      this.$message.warning("每类附件最多选择 10 个文件");
    },
    publish(item) {
      this.$ajax
        .post("/admin/courseware/publish", {
          id: item.id,
          publishStatus: item.publishStatus ? 0 : 1,
        })
        .then((res) => {
          this.$message.success("修改成功");
          this.getList();
        });
    },
    confirm() {
      this.form.ranges = this.range.join(",");
      this.form.organizationIds = this.organizationId.join(",");
      this.$ajax.post("/admin/courseware/save", this.form).then((res) => {
        this.$message.success("保存成功");
        this.show = false;
        this.getList();
      });
    },
    getList() {
      this.$ajax.post("/admin/courseware/pageList", this.query).then((res) => {
        this.list = res.list;
        this.total = res.total;
      });
    },
  },
  watch: {
    time(val) {
      if (!val) {
        this.query.startTime = "";
        this.query.endTime = "";
        return;
      }
      this.query.startTime = val[0];
      this.query.endTime = val[1];
    },
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 20px;
  color: rgb(153, 153, 153);
  margin: 15px 0;
}

.operation-buttons {
  white-space: nowrap;
}

.delete-button {
  color: #f56c6c;
}

.school-toggle {
  padding: 0;
}

.school-toggle i {
  margin-left: 6px;
}

.school-checkboxes {
  max-height: 220px;
  margin-top: 8px;
  padding: 10px 12px 2px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fafafa;
}

.attachment-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin: 0 0 22px 116px;
}

.attachment-card {
  min-height: 92px;
  padding: 14px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fafafa;
}

.attachment-title {
  margin-bottom: 10px;
  color: #606266;
  font-weight: 600;
}

::v-deep .course-dialog {
  max-width: calc(100vw - 32px);
}

::v-deep .course-dialog .el-dialog__body {
  max-height: 75vh;
  overflow-y: auto;
}

::v-deep .attachment-card .el-upload-list__item-name {
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 768px) {
  .attachment-grid {
    grid-template-columns: 1fr;
  }
}
</style>
